import { createChatDialogStore } from '@/entities/ChatDialog/model/store';
import { appChatService } from '../api/appChatService';

/** Хранит переписку поддержки в приложении */
export const useAppChatStore = createChatDialogStore(appChatService);
